import React from "react";

export default class Textarea extends React.Component {
    componentDidUpdate(prevProps) {
        if (!prevProps.meta.active && this.props.meta.active) {
            this.input.focus();
        }
    }

    render() {
        let error;
        if (this.props.meta.touched && this.props.meta.error) {
            error = <div className="form-error">{this.props.meta.error}</div>;
        }

        let warning;
        if (this.props.meta.touched && this.props.meta.warning) {
            warning = (
                <div className="form-warning">{this.props.meta.warning}</div>
            );
        }

        return (
            <div className="form-textarea">
                <label htmlFor={this.props.input.name}>
                    {this.props.label}
                </label>
                <h4 className="error-message">{error}</h4>
                <h4 className="warning-message">{warning}</h4>
                <textarea
                    {...this.props.input}
                    id={this.props.input.name}
                    type={this.props.type}
                    ref={input => (this.input = input)}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/textarea.js